import { writable } from 'svelte/store';
// Watch variable changes.
export const watcher = (initialValue, watchFunction) => {
    const { subscribe, update } = writable(initialValue);
    return {
        subscribe,
        set: (value) => {
            update((oldvalue) => {
                watchFunction(oldvalue, value);
                return value;
            });
        }
    };
};
